import BetslipErrorImpl from './betslip-error.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;
/**
 * Betslip error. The common component for displaying error message on Betslip and QuickBetslip.
 *
 * @class BetslipError
 * @name view
 * @memberof Mojito.Modules.Betslip.BetslipView
 */

/**
 * BetslipError prop types.
 *
 * @property {string} [message] - Message for error layer.
 * @property {Function} [onOkClick = ()=>{}] - Callback on OK button click.
 *
 * @memberof Mojito.Modules.Betslip.BetslipView.BetslipError
 */
const propTypes = {
    message: PropTypes.string,
    onOkClick: PropTypes.func,
};

const defaultProps = {
    onOkClick: noop,
};

export default UIView('BetslipError', BetslipErrorImpl, propTypes, defaultProps);
